import React from "react";

import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { cn } from "@/lib/utils";

import { getContactInitials } from "../partner-whatsapp-inbox.utils";

export interface ThreadAvatarProps {
  displayName: string | null | undefined;
  phone: string;
  size?: "sm" | "md";
  className?: string;
}

export const ThreadAvatar: React.FC<ThreadAvatarProps> = ({
  displayName,
  phone,
  size = "md",
  className,
}) => {
  const dim = size === "sm" ? "h-10 w-10 text-xs" : "h-11 w-11 text-sm";
  return (
    <Avatar className={cn(dim, className)}>
      <AvatarFallback
        className={cn(
          dim,
          "bg-emerald-600/15 text-emerald-700 dark:text-emerald-300 font-semibold",
        )}
      >
        {getContactInitials(displayName, phone)}
      </AvatarFallback>
    </Avatar>
  );
};
